var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',_vm._l((_vm.empreendimentos),function(obra,index){return _c('v-col',{key:index,attrs:{"cols":"12","md":"12"}},[_c('table-documentos',{attrs:{"object":_vm.object,"obraId":obra,"userId":_vm.userId}})],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }